import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  enableDarkmode = false;

  private readonly localStorageDarkModeSettingKey = "fairapp_darkskin";

  initialize() {
    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)");
    const darkEnabled =
      localStorage.getItem(this.localStorageDarkModeSettingKey) === null
        ? systemPrefersDark.matches
        : this.loadThemeSettingFromLocalStorage();
    this.saveThemeSettingToLocalStorage(darkEnabled);
    this.setDarkMode(darkEnabled);
  }

  toggleDarkTheme() {
    const darkEnabled = !this.loadThemeSettingFromLocalStorage();
    this.saveThemeSettingToLocalStorage(darkEnabled);
    this.setDarkMode(darkEnabled);
  }

  private saveThemeSettingToLocalStorage(darkModeEnabled: boolean) {
    localStorage.setItem(this.localStorageDarkModeSettingKey, String(darkModeEnabled));
  }

  private loadThemeSettingFromLocalStorage(): boolean {
    return JSON.parse(localStorage.getItem(this.localStorageDarkModeSettingKey));
  }

  private setDarkMode(enabled: boolean) {
    this.enableDarkmode = enabled;
    document.body.classList.toggle("dark-layout", enabled);
    document.body.classList.toggle("default-layout", !enabled);
  }
}
